var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex"},[_c('img',{staticClass:"m-2",attrs:{"src":"img/rw/rw.svg","id":"rwicon","alt":"rumahweb"}}),_vm._v(" "),_c('br'),_c('div',{staticClass:"tagline ml-2"},[_c('h5',{staticClass:"font-weight-bold mt-2 mb-0"},[_vm._v("Rumahweb Indonesia")]),_c('small',[_vm._v("Painless Hosting Solution")])])])
}]

export { render, staticRenderFns }